"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable array-callback-return */
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const md_1 = require("react-icons/md");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const Menu = (props) => {
    const { label, options } = props;
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Button_1.default, { onClick: handleClick, fullWidth: false, size: "small" },
            react_1.default.createElement(react_1.Fragment, null,
                label,
                " ",
                react_1.default.createElement(md_1.MdArrowDropDown, null))),
        react_1.default.createElement(Menu_1.default, { getContentAnchorEl: null, anchorEl: anchorEl, keepMounted: true, open: !!anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            } }, options.map(({ label, onClick, visible }) => {
            if (typeof visible !== 'boolean' || visible) {
                return (react_1.default.createElement(MenuItem_1.default, { key: label, onClick: () => {
                        handleClose();
                        onClick();
                    } }, label));
            }
        }))));
};
Menu.propTypes = {
    label: prop_types_1.default.any.isRequired,
    options: prop_types_1.default.array.isRequired,
};
exports.default = Menu;
